import React, { useEffect, useState } from 'react';
import { Button, InputNumber, Space, Divider, Typography } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

interface CustomPaginationProps {
	currentPage: number;
	pageSize: number;
	currentDataLength: number;
	onPageChange: (page: number) => void;
}

const CustomPagination: React.FC<CustomPaginationProps> = ({
	                                                           currentPage,
	                                                           pageSize,
	                                                           currentDataLength,
	                                                           onPageChange,
                                                           }) => {
	const [inputPage, setInputPage] = useState<number>(currentPage);

	// 외부(부모)에서 페이지가 변경되면 입력창의 숫자도 동기화
	useEffect(() => {
		setInputPage(currentPage);
	}, [currentPage]);

	// 현재 데이터 개수가 pageSize와 일치해야만 다음 페이지가 있는 것으로 판단
	const hasNextPage = currentDataLength === pageSize;

	// [기능 1] 이전 페이지 이동
	const handlePrevPage = () => {
		if (currentPage > 1) {
			onPageChange(currentPage - 1);
		}
	};

	// [기능 2] 다음 페이지 이동
	const handleNextPage = () => {
		if (hasNextPage) {
			onPageChange(currentPage + 1);
		}
	};

	// [기능 3] 입력한 페이지 번호로 이동
	const handleJumpPage = () => {
		// 💡 현재 페이지와 다른 숫자가 입력되었을 때만 이동하도록 방어
		if (inputPage && inputPage > 0 && inputPage !== currentPage) {
			onPageChange(inputPage);
		}
	};

	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				gap: '16px',
			}}
		>
			{/*이전 / 다음 이동 버튼 */}
			<Space size="middle">
				<Button
					icon={<LeftOutlined />}
					onClick={handlePrevPage}
					disabled={currentPage <= 1}
				>
					이전
				</Button>

				<Typography.Text strong style={{ fontSize: '14px', minWidth: '70px', textAlign: 'center' }}>
					{currentPage} 페이지
				</Typography.Text>

				<Button
					onClick={handleNextPage}
					disabled={!hasNextPage}
				>
					다음 <RightOutlined />
				</Button>
			</Space>

			<Divider type="vertical" style={{ height: '20px', borderColor: '#d9d9d9' }} />

			{/* 입력한 페이지 번호로 이동 */}
			<Space>
				<span style={{ color: '#555', fontSize: '13px' }}>페이지 이동:</span>
				<InputNumber
					min={1}
					value={inputPage}
					onChange={(val) => setInputPage(val ?? 1)}
					onPressEnter={handleJumpPage} // 엔터키 지원
					style={{ width: '70px' }}
				/>
				<Button type="primary" onClick={handleJumpPage}>
					이동
				</Button>
			</Space>
		</div>
	);
};

export default CustomPagination;